import { makeAutoObservable } from 'mobx'

export class RcsField {
  value: string | null
  draft: string | null

  constructor(value: string | null = null) {
    this.value = value
    this.draft = value
    makeAutoObservable(this)
  }

  get isDirty() {
    return this.value !== this.draft
  }

  sync = (value: string | null) => {
    this.value = value
    this.draft = value
  }

  setDraft = (value: string | null) => {
    this.draft = value
  }

  reset = () => {
    this.draft = this.value
  }
}
